// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3R8kS","overflowing":"ReadFullNote_overflowing__jYggf"};